var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-container"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:(_vm.dragConfig),expression:"dragConfig"}],staticClass:"flex-column flex-center",attrs:{"id":"global-component-body"}},[_c('p',[_vm._v("left: "+_vm._s(_vm.left))]),_c('p',[_vm._v("top: "+_vm._s(_vm.top))]),_c('p',[_vm._v("我是全局组件")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }